import { render, staticRenderFns } from "./UpgradeToPremium.vue?vue&type=template&id=7b70523a&"
import script from "./UpgradeToPremium.vue?vue&type=script&lang=js&"
export * from "./UpgradeToPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports